import React, { Fragment, useCallback, useState } from "react";
import makeStyles from "@mui/styles/makeStyles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/pro-regular-svg-icons";
import { anyTrue, notBlank } from "../../../util/ext";

import ButtonBase from "@mui/material/ButtonBase";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

import NewContentGroupDialog from "./create-new-dialog/NewContentGroupDialog";
import { useIsAdmin, useIsUserIAPManager } from "../../../auth/authUtils";

const useStyles = makeStyles(theme => ({
  card: {
    backgroundColor: theme.palette.primary.green.light,
    height: 56,
    borderWidth: 1.5,
    borderStyle: "solid",
    borderColor: theme.palette.primary.green.dark,
    borderRadius: 10,
    padding: "0 10px",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: theme.palette.primary.green.dark,
    },
  },

  title: {
    fontSize: "1.2rem",
    textAlign: "left",
    fontWeight: 600,
    [theme.breakpoints.up("md")]: {
      fontSize: "1.4rem",
    },
  },
}));

const EmptyContentGroupCard = ({
  parent,
  addToParent,
  parentPrevMediaListCount,
}) => {
  const classes = useStyles();
  const isAdmin = useIsAdmin();
  const isIapManager = useIsUserIAPManager();

  const [open, setOpen] = useState(false);
  const handleClick = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const label = useCallback(() => {
    const mediaType = anyTrue([isAdmin, isIapManager])
      ? "Content Group"
      : "Collection";
    const action = notBlank(parent) ? "Add" : "Create";
    return `${action} New ${mediaType}`;
  }, [isAdmin, isIapManager, parent]);

  return (
    <Fragment>
      <NewContentGroupDialog
        open={open}
        handleClose={handleClose}
        parent={parent}
        addToParent={addToParent}
        parentPrevMediaListCount={parentPrevMediaListCount}
      />
      <ButtonBase onClick={handleClick} style={{ width: "100%" }}>
        <Grid
          className={classes.card}
          container
          alignItems="center"
          justifyContent="space-around"
        >
          <Typography className={classes.title} noWrap>
            <span style={{ paddingRight: 20 }}>
              <FontAwesomeIcon icon={faPlus} />
            </span>
            {label()}
          </Typography>
        </Grid>
      </ButtonBase>
    </Fragment>
  );
};

export default EmptyContentGroupCard;
